import { CommonModule } from '@angular/common';
import {AfterViewInit, ChangeDetectorRef, Component, inject, OnInit, ViewChild} from '@angular/core';
import { TabViewModule } from 'primeng/tabview';
import { AdminTipoTramiteComponent } from './admin-tipo-tramite/admin-tipo-tramite.component';
import { AdminCategorizacionesComponent } from './admin-categorizaciones/admin-categorizaciones.component';
import { AdminActividadesComponent } from './admin-actividades/admin-actividades.component';
import { AdminDependenciaTramiteComponent } from './admin-dependencia-tramite/admin-dependencia-tramite.component';
import { TranslateModule } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';
import { CustomTitle } from 'lib-base';
import { ReporteLogosComponent } from './reporte-logos.component';
import {CustomTitleDirective} from "../../../shared/clases/custom-title.directive";

@Component({
  selector: 'app-admin-tramites',
  standalone: true,
  imports: [CommonModule, TabViewModule, TranslateModule, CustomTitle,
    AdminTipoTramiteComponent, AdminCategorizacionesComponent, AdminActividadesComponent, AdminDependenciaTramiteComponent, ReporteLogosComponent],
  templateUrl: './admin-tramites.component.html',
  styleUrls: ['../../../../assets/styles/style.mantenimiento.scss']
})
export class AdminTramitesComponent implements OnInit, AfterViewInit {
  activeTabIndex: number = 0;

  @ViewChild(AdminTipoTramiteComponent) tipoTramiteComponent !: AdminTipoTramiteComponent;
  @ViewChild(AdminCategorizacionesComponent) categorizacionesComponent !: AdminCategorizacionesComponent;
  @ViewChild(AdminActividadesComponent) adminActividadesComponent !: AdminActividadesComponent;
  @ViewChild(AdminDependenciaTramiteComponent) adminDependenciaTramiteComponent !: AdminDependenciaTramiteComponent;
  @ViewChild(ReporteLogosComponent) reporteLogosComponent !: ReporteLogosComponent;

  private titleService:CustomTitleDirective = inject(CustomTitleDirective);

  constructor(private readonly _route: ActivatedRoute, private readonly cdr: ChangeDetectorRef) {
  }

  ngOnInit(): void {
    this.titleService.changeTitle('msg.panelDeTrámites')
  }


  ngAfterViewInit(): void {
    this._route.queryParams.subscribe(params => {
      let index = Number(params['tabIndex'] ?? 0);
      this.activeIndexChange(index);
      this.cdr.detectChanges();
    });
  }

  activeIndexChange(index: number) {
    this.activeTabIndex = index;
    if (this.activeTabIndex === 0)
      this.tipoTramiteComponent.getTiposTramites();
    else if (this.activeTabIndex === 1)
      this.categorizacionesComponent.getCategorizaciones();
    else if (this.activeTabIndex === 2)
      this.adminActividadesComponent.getActividades();
    else if (this.activeTabIndex === 3)
      this.adminDependenciaTramiteComponent.getDependencias();
    else
      this.reporteLogosComponent.getReporteLogos();
  }
}
